import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BankRecord, DebitOrder, IBankDetails } from '../../models/finance';
import { AccountLinks, IAccountHolder } from '../../models/user';
import { IBursar } from '../../graphql/models/gqlModels';

export const FinanceActions = createActionGroup({
    source: 'Finance',
    events: {
        'Load Debit Orders': emptyProps(),
        'Load Debit Orders Success': props<{ debitOrders: DebitOrder[] }>(),
        'Load Debit Orders Failure': props<{ error: unknown }>(),
        'Load Banking Details': props<{ accountLinks: AccountLinks[] }>(),
        'Load Banking Details Success': props<{ bankDetails: IBankDetails[] }>(),
        'Load Banking Details Failure': props<{ error: unknown }>(),
        'Load Bank Records': props<{ accountLinks: AccountLinks[] }>(),
        'Load Bank Records Success': props<{ statements: BankRecord[] }>(),
        'Load Bank Records Failure': props<{ error: unknown }>(),
        'Set Date Range': props<{ fromDate: Date; toDate: Date }>(),
        'Set Selected Account Links': props<{ accountLinks: AccountLinks }>(),
        'Load Account Holder Details': emptyProps(),
        'Load Account Holder Details Success': props<{ accountHolder: IAccountHolder }>(),
        'Load Account Holder Details Failure': props<{ error: unknown }>(),
        'Set Account Bursar': props<{ accountBursar: IBursar | null }>()
    }
});